import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";

interface MediaCardProps {
  item: MediaItem;
  showSynopsis?: boolean;
}

export default function MediaCard({ item, showSynopsis = false }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-secondary-300"
    >
      <div className="relative w-full overflow-hidden bg-background-200">
        <div className="aspect-[2/3] w-full">
          <img
            src={item.poster}
            alt={`${item.title} 海报`}
            title={`${item.title} - 555电影网`}
            className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-semibold text-primary-950">
          <i className="ri-star-fill text-[11px]"></i>
          {item.rating.toFixed(1)}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-primary-900/80 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {item.type === "movie" ? "电影" : "剧集"}
        </span>
      </div>

      <div className="p-3">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-900 transition-colors group-hover:text-secondary-600">
          {item.title}
        </h3>
        <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
          <span>{item.year}</span>
          <span className="h-1 w-1 rounded-full bg-foreground-300"></span>
          <span className="truncate">{item.region}</span>
          {item.type === "tv" && item.episodes ? (
            <>
              <span className="h-1 w-1 rounded-full bg-foreground-300"></span>
              <span>全{item.episodes}集</span>
            </>
          ) : null}
        </p>
        <div className="mt-2 flex flex-wrap gap-1">
          {item.genres.slice(0, 3).map((genre) => (
            <span
              key={genre}
              className="rounded bg-secondary-50 px-1.5 py-0.5 text-[11px] text-secondary-700"
            >
              {genre}
            </span>
          ))}
        </div>
        {showSynopsis && (
          <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500">
            {item.synopsis}
          </p>
        )}
      </div>
    </Link>
  );
}